import { createSlice } from '@reduxjs/toolkit';

// api client
import apiClient from './apiClient.js'


const REQUESTS = {
  index: (outputFields = `id`) => {
    return `query {
      offices{
        ${outputFields}
      }
    }`   
  },
  get: ({id}, outputFields = `id`) =>{
    return `query {
      office(id: "${id}"){
        ${outputFields}
      }
    }`
  },
  create: ({ name, projectId }, outputFields = `id`) => {
    // 20/1/2025 project field presence depend on old vs new inspection handling system (projects or missions)
    const projectIdField = projectId ? `, projectId: "${projectId}"` : '';

    return `mutation {
      createOffice(office: {name: "${name}"${projectIdField}}){
        ${outputFields}
      }
    }`;
  },
  delete: (id, projectId) => {
    return `mutation {
      deleteOffice(id:"${id}", projectId: "${projectId}")
    }`;
  },
  addInOffice: ({id, missionIds}) => {
    return `mutation {
      addInOffice(id:"${id}",missionIds:${JSON.stringify(missionIds)})
    }`
  },
  addInProjectOffice: ({ id, missionIds, userIds, roles }) => {
    return `mutation {
      addInProjectOffice(id: "${id}"${missionIds ? `, missionIds: ${JSON.stringify(missionIds)}` : ''}${userIds ? `, userIds: ${JSON.stringify(userIds)}` : ''}${roles ? `, roles: ${JSON.stringify(roles)}` : ''})
    }`;
  },
  removeInProjectOffice: ({ id, projectId, missionIds, userIds, roles }) => {
    return `mutation {
      removeInProjectOffice(id: "${id}"${missionIds ? `, missionIds: ${JSON.stringify(missionIds)}` : ''}${userIds ? `, userIds: ${JSON.stringify(userIds)}` : ''}${roles ? `, roles: ${JSON.stringify(roles)}` : ''})
    }`
  },
}

const initialState = {
  all: []
}

export const officesSlice = createSlice({
  name: 'offices',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setOffices: (state, {payload: {offices}}) => {
      return {
        ...state,
        all: offices
      }
    },
    createOffice: (state, {payload}) => {
      return {
        ...state,
        all: [
          ...state.all,
          payload
        ]
      }
    },
  }
});

export const selectOffices = (state) => state.offices.all
export const { setOffices, createOffice } = officesSlice.actions

export const officesApi = {
  create: async ({name, projectId}, outputFields, next) => {
    const result = await apiClient.req(REQUESTS.create({
      name,
      projectId
    }, outputFields))
    next(result.data.data.createOffice)
  },
  delete: async ({id, projectId}, next) => {
    const result = await apiClient.req(REQUESTS.delete(
      id,
      projectId
    ));
    next(result.data.data.deleteOffice);
  },
  index: async (outputFields, next) => {
    const result = await apiClient.req(REQUESTS.index(outputFields))
    next(result.data.data)
  },
  get: async (id,outputFields, next) => {
    const result = await apiClient.req(REQUESTS.get({id},outputFields))
    next(result.data.data)
  },
  addInProjectOffice: async ({id, missionIds, userIds, roles}, outputFields, next) => {
    const result = await apiClient.req(REQUESTS.addInProjectOffice({id, missionIds, userIds, roles}))
    next(result.data.data)
  },
  removeInProjectOffice: async ({id, missionIds, userIds, roles}, outputFields, next) => {
    const result = await apiClient.req(REQUESTS.removeInProjectOffice({id, missionIds, userIds, roles}))
    next(result.data.data)
  }
}

export default officesSlice.reducer;
